module.exports = __webpack_public_path__ + "static/img/brown.6fe5861f.png";